<template>
  <div class="navigation" :class="{ 'is-active': active }" style="padding: 0;">
    <div style="height: 100%; width: 100%;" data-simplebar>
      <aside class="menu" style="padding: 1rem;">
        <div class="is-hidden-desktop">
          <user-tile :user="$store.state.auth.user"></user-tile>

          <ul class="menu-list">
            <a @click="logout">
              <span>{{ $t("auth.logout") }}</span>
            </a>
          </ul>
        </div>

        <div v-for="(item, index) in filteredMenu" :key="index">
          <p class="menu-label">{{ item.section }}</p>

          <ul class="menu-list mb-4">
            <li v-for="(link, index) in item.links" :key="index">
              <router-link :to="link.path">{{ link.label }}</router-link>
            </li>
          </ul>
        </div>
      </aside>
    </div>
  </div>
</template>

<script>
import "simplebar";
import "simplebar/dist/simplebar.css";

export default {
  data() {
    return {
      active: false,
      menu: [
        {
          section: this.$tc("general"),
          links: [
            {
              path: "/dashboard",
              permission: "dashboard",
              label: this.$tc('dashboard.app.title'),
            }
          ],
        },

        {
          section: "Analytics",
          links: [
            {
              path: "/analytics/overview",
              label: "Analytics",
              permission: "analytics",
            },
            // {
            //   path: "/magazine/stats/read-pages",
            //   label: "Users",
            //   permission: "analytics",
            // },
            {
              path: "/magazine/downloads",
              label: "Downloads",
              permission: "analytics",
            },
          ],
        },
        {
          section: "Report",
          links: [
            {
              path: "/analytics/user-analytics",
              label: this.$t('analytics.title'),
              permission: "report",
            },
            {
              path: "/analytics/order-analytics",
              label: this.$tc('analytics.purchase_data'),
              permission: "report",
              hide: !this.$store.getters.hasSubscription
            },
            {
              path: "/analytics/downloads",
              label: this.$tc('download.report.title'),
              permission: "report",
            },
            {
              path: "/analytics/views",
              label: this.$tc('download.report.vReport'),
              permission: "report",
            },
          ]
        },
        {
          section: this.$tc('promotion'),
          links: [
            {
              path: "/analytics/promo",
              label: this.$tc('promotions.promo'),
              permission: "promotion",
            },
            {
              path: "/campaigns",
              permission: "promotion",
              label: this.$tc('promotions.campaign'),
            },

          ],
        },
        {
          section: this.$t('magazine'),
          links: [
            {
              path: "/publishers",
              permission: "publishers",
              label: this.$tc("publisher._name", 2),
            },
            {
              service: "magazine2",
              path: "/magazine/magazines",
              label: this.$tc('magazines.magazines'),
              permission: "magazine",
            },
            {
              service: "magazine2",
              path: "/magazine/magazine/issues",
              label: this.$tc('magazines.issues'),
              permission: "magazine",
            },
            {
              service: "magazine2",
              path: "/magazine/categories",
              label: this.$tc('magazines.categories'),
              permission: "magazine",
            },
            {
              service: "feeds",
              path: "/feeds",
              label: this.$tc('magazines.feeds'),
              permission: "magazine",
            },
            {
              service: "magazine2",
              path: "/collections",
              permission: "magazine",
              label: this.$tc("collection._name", 2)
            },
          ],
        },

        {
          section: this.$tc('revenue'),
          links: [
            {
              path: "/revenue/shares",
              label: this.$tc('magazines.income'),
              permission: "revenue",
            },
            {
              path: "/revenue/reports",
              label: this.$tc('magazines.revenue'),
              permission: "revenue",
            },
          ]
        },

        {
          section: this.$tc('subscription'),
          links: [
            {
              service: "magazine2",
              path: "/orders",
              label: this.$tc('subscriptions.orders'),
              permission: "subscription",
              hide: !this.$store.getters.hasSubscription
            },
            {
              path: "/sales",
              label: this.$tc("selling.sales", 2),
              permission: "subscription",
              hide: !this.$store.getters.hasSubscription
            },
            {
              path: "/accounting/undistributed",
              label: this.$tc("income.undistributed", 2),
              permission: "subscription",
              hide: !this.$store.getters.hasSubscription
            },
            {
              service: "magazine2",
              path: "/magazine/subscriptions",
              label: this.$tc('subscriptions.subscriptions'),
              permission: "subscription",
              hide: !this.$store.getters.hasSubscription
            },
            {
              service: "magazine2",
              path: "/magazine/complementary-access",
              label: this.$tc('subscriptions.activations'),
              permission: "subscription",
              hide: !this.$store.getters.hasSubscription
            },
          ]
        },

        {
          section: this.$tc('adscontent'),
          links: [
            {
              service: "Ads",
              path: "/ads",
              label: this.$tc('ads.ads'),
              permission: "ads",
            },
            {
              path: "/ads-views",
              label: this.$tc('ads.adsview'),
              permission: "ads",
            },
          ],
        },

        {
          section: this.$tc('wifi'),
          links: [
            {
              service: "Wifi",
              path: "/wifi/vendors",
              label: this.$tc('wifi'),
              permission: "wifi",
            }
          ],
        },

        {
          section: this.$tc("user._name", 2),
          links: [
            {
              path: "/users",
              label: this.$tc("user._name", 2),
              permission: "users",
            },
            {
              path: "/devices",
              label: this.$tc("device._name", 2),
              permission: "users",
            },
            {
              service: "support-ticket",
              path: "/reviews",
              label: this.$tc("comment._name", 2),
              permission: "users",
            },
            {
              service: "feedback",
              path: "/feedback",
              label: this.$tc('feedback.title'),
              permission: "users",
            },
          ],
        },

        {
          section: this.$tc("logs._name"),
          links: [
            {
              path: "/searches",
              label: this.$tc("search._name", 2),
              permission: "logs",
            },
            {
              path: "/activity-log",
              label: this.$tc("activity_log._name", 2),
              permission: "logs"
            },
          ],
        },

        {
          section: this.$tc('banners'),
          links: [
            {
              path: "/marketing/sliders",
              label: this.$tc("slider._name", 2),
              permission: "banners"
            },
            {
              path: "/marketing/banners",
              label: this.$tc("banner._name", 2),
              permission: "banners"
            },
          ],
        },

        {
          section: this.$t("other"),
          links: [
            {
              path: "/mass-mail",
              label: this.$t("mass_mail"),
              permission: "settings"
            },
            {
              path: "/settings",
              label: this.$t("settings"),
              permission: "settings"
            },
            {
              path: "/pns",
              label: this.$tc("notification._name", 2),
              permission: "notifications"
            },
            {
              path: "/managers",
              label: this.$t('manager'),
              permission: "managers"
            },
            {
              path: "/review-app/accounts",
              label: this.$tc('review.title'),
              permission: "review_accounts",
            },
          ],
        },
      ],
    };
  },

  computed: {
    role() {
      return this.$store.state.auth.manager.role;
    },

    permissions() {
      return this.$store.state.auth.manager
        ? this.$store.state.auth.manager.permissions
        : [];
    },

    filteredMenu() {
      return this.menu
        .map((section) => {
          section.links = section.links.filter((link) => {
            // Тохиргоогоор цэсийг хассан бол.
            if (link.hide === true) {
              return false;
            }

            // Хэрэглэгчид тухайн цэсийг ашиглах эрх байгаа эсэхийг шалгана.
            if (link.permission && this.permissions.includes(link.permission)) {
              return true;
            }
            // Дээрх нөхцөлийг хангахгүй бол цэсийг харуулахгүй.
            return false;
          });

          return section;
        })
        .filter((section) => {
          return section.links.length > 0;
        });
    },
  },

  created() {
    this.$router.afterEach(() => {
      this.active = false;
    });

    this.$root.$on("toggleMenu", () => {
      this.active = !this.active;
    });
  },

  methods: {
    logout() {
      window.localStorage.setItem('token', null);

      this.active = false;

      this.$buefy.dialog.confirm({
        message: this.$t("auth.confirm"),
        cancelText: this.$t("cancel"),
        confirmText: this.$t("auth.logout"),
        onConfirm: () => {
          this.$buefy.loading.open();

          this.$http
            .post("logout", {}, {baseURL: "/"})
            .takeAtLeast(800)
            .then(() => (window.location.href = "/admin"));
        },
      });
    },
  },
};
</script>
